import React, { useState, useEffect } from 'react';
import { NavLink, LoadingOverlay, Image } from '@mantine/core';
import styles from './styles.module.scss';
import { categoryClicked } from "@/utils/event";
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { refreshGameList, recordCategoryClick } from '@/store/features/gameSlice';
import { STATIC_PAGES } from "@/const";

export default React.memo(function Sidebar({ menuData = [] }) {
  const [loading, setLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentMenu, setCurrentMenu] = useState({id: ""});
  const router = useRouter();
  const dispatch = useDispatch();

  // methods
  // 记录路由的点击
  const handleMenuClick = (menu) => {
    dispatch(refreshGameList());
    setCurrentMenu(menu);
    // 记录路由的点击到 Redux
    dispatch(recordCategoryClick({path: menu.path}));
    // 保留原有的事件记录（如果需要的话）
    categoryClicked({path: menu.path});

    router.push({
      pathname: `/game/${menu.path}`,
    });
  };

  // 获取菜单列表
  useEffect(() => {
    // 等待路由准备就绪
    if (!router.isReady) return;

    const { slug } = router.query || {};

    // 设置当前菜单
    if (slug) {
      if (STATIC_PAGES.some((pagePath) => pagePath.includes(slug))) {
        setCurrentMenu({ path: slug, id: "" });
        dispatch(recordCategoryClick({path: slug}));
      }
    } else {
      setCurrentMenu({ path: "", id: "" });
    }
  }, [router.isReady, router.query]); // 添加 router.isReady 作为依赖

  return (
    <div
      className={styles.sidebar}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <div className={`${styles.sidebar_content} ${isExpanded ? styles.expanded : ''}`}>
        { loading ?
            <>
              <LoadingOverlay
                  visible={loading}
                  zIndex={3000}
                  overlayProps={{ radius: 'md', opacity: 0 }}
                  loaderProps={{ color: 'white', type: 'bars' }}></LoadingOverlay>
            </> : menuData.map((item) => (
            <NavLink
              key={item.id}
              href={`/game/${item.path}`}
              label={item.name}
              noWrap={true}
              leftSection={<Image src={item.icon} alt={item.name} width={32} height={32} />}
              childrenOffset={28}
              onClick={() => {
                event.preventDefault();
                handleMenuClick(item)
              }}
              classNames={{root: `${styles.nav_link} ${item.path === currentMenu.path ? styles.active : ''}`, section: isExpanded ? styles.nav_link_section_expanded : styles.nav_link_section, chevron: isExpanded ? '' : styles.chevron_hidden, children: `${styles.nav_link_children}`}}
            >
              { (item.children.length > 0) && item.children.map((child) => (
                  <NavLink
                      key={child.id}
                      label={isExpanded ? child.name : ''}
                      leftSection={<Image src="/static/icon/popcorn.png" width={32} height={32} />}
                      onClick={() => handleMenuClick(child)}
                      classNames={{root: `${styles.nav_link} ${child.path === currentMenu.path ? styles.active : ''}`}}
                  ></NavLink>))
              }
            </NavLink>
        )) }
      </div>
    </div>
  );
});